import { Component, OnInit } from '@angular/core';
import { BroadcastService } from "../../../Helpers/broadcast.service";
import { CrudService } from "../../../Services/crud.service"

enum Event {
  LogIN  
}

@Component({
    selector: 'app-common-modal', templateUrl: './common-modal.component.html',
    standalone: false
})
export class CommonModalComponent implements OnInit {

  constructor(private broadcastService: BroadcastService<Event>, private crudService: CrudService) { }

  ngOnInit() { 
  }

  broadcastEvent(response) {
    this.broadcastService.BroadcastEvent(Event.LogIN.toString(), {response:response});
  }

  login() { 
    localStorage.setItem("AuthToken", "true");    
    // dummy login service
    var payload = {id : 1}
    this.crudService.get(payload, () => {
      this.broadcastService.BroadcastEvent(Event.LogIN.toString(), {response:"Success"});
    }, 'posts/1');
  }

}
